import { cn } from "@/lib/utils"

// A procedurally generated "flow field" of thin horizontal lines. Each line is
// a base row displaced by a few low-frequency sine components; a small per-line
// phase drift makes neighbouring lines converge and diverge, producing the soft
// woven pinch-points of a topographic wave pattern. Values are deterministic so
// server and client render identically. Shared by the signup marketing panel
// (left) and the form column (right) so both sides read as one texture.
const PATTERN_WIDTH = 1200
const PATTERN_HEIGHT = 900
const LINE_GAP = 16
const SAMPLE_STEP = 16

function buildWavePaths(): string[] {
  const paths: string[] = []
  const lineCount = Math.ceil(PATTERN_HEIGHT / LINE_GAP) + 8
  for (let i = 0; i < lineCount; i++) {
    const baseY = -40 + i * LINE_GAP
    let d = ""
    for (let x = -48; x <= PATTERN_WIDTH + 48; x += SAMPLE_STEP) {
      const y =
        baseY +
        30 * Math.sin(0.0056 * x + 0.115 * i) +
        14 * Math.sin(0.0129 * x + 0.062 * i + 1.7) +
        6 * Math.sin(0.0271 * x + 0.09 * i + 0.5)
      d += `${x === -48 ? "M" : "L"}${x.toFixed(1)} ${y.toFixed(1)} `
    }
    paths.push(d.trim())
  }
  return paths
}

const WAVE_PATHS = buildWavePaths()

export function SignupFlowLines({
  className,
  maskImage,
}: {
  className?: string
  maskImage?: string
}) {
  return (
    <svg
      aria-hidden="true"
      viewBox={`0 0 ${PATTERN_WIDTH} ${PATTERN_HEIGHT}`}
      preserveAspectRatio="xMidYMid slice"
      fill="none"
      className={cn(
        "text-brand pointer-events-none absolute inset-0 h-full w-full",
        className
      )}
      style={maskImage ? { WebkitMaskImage: maskImage, maskImage } : undefined}
    >
      {WAVE_PATHS.map((d) => (
        <path
          key={d}
          d={d}
          stroke="currentColor"
          strokeWidth={1}
          strokeLinecap="round"
        />
      ))}
    </svg>
  )
}
